import * as React from 'react';

import { Link } from '../link/link';

const s = require('./store_link.css');

interface IProps {
  onClick(): void;
  store: 'apple' | 'google';
  url: string;
}

export const StoreLink = (props: IProps) =>
  <Link
    className={`${s['c-sms-form-store-button']} ${s['c-' + props.store + '-btn']}`}
    onClick={() => props.onClick()}
    href={props.url}
    target="_blank">
  </Link>;
